var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TextField } from '@material-ui/core';
import React, { useRef, useState } from 'react';
const getValue = (value, float) => {
    console.log('value', value);
    if (value === '0' || value === 0)
        return '0';
    value = value !== null && value !== void 0 ? value : '';
    return float ? value : value.toString();
};
export const EntityNumberField = (_a) => {
    var _b, _c;
    var { column, plugin, label, placeholder, helperText, error, onChange } = _a, props = __rest(_a, ["column", "plugin", "label", "placeholder", "helperText", "error", "onChange"]);
    const isNumeric = column.type === 'numeric';
    const [value, setValue] = useState(getValue(props.value, isNumeric));
    const validationError = (_c = (_b = plugin.edit) === null || _b === void 0 ? void 0 : _b.validateError) === null || _c === void 0 ? void 0 : _c.call(_b, column, value);
    const timeoutRef = useRef();
    const handleChange = (event) => {
        const result = event.target.value;
        if (result !== 0 &&
            result !== '0' &&
            (typeof result === 'undefined' || result === null)) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        const value = isNumeric ? parseFloat(result) : parseInt(result);
        if (isFinite(value)) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                console.log('value', value);
                onChange === null || onChange === void 0 ? void 0 : onChange(value);
            }, 300);
        }
    };
    return (React.createElement(TextField, { className: 'entity-field', type: 'number', fullWidth: true, 
        // disabled={disabled}
        size: 'small', label: label, value: getValue(value, isNumeric), placeholder: placeholder || 'Enter a number', error: Boolean(error) || Boolean(validationError), helperText: validationError || helperText, variant: 'outlined', onChange: event => {
            setValue(event.target.value);
            handleChange(event);
        } }));
};
//# sourceMappingURL=EntityNumberField.js.map